module.exports = __webpack_public_path__ + "img/logo.0f938568.png";